import { createContext } from 'react';
export const getDefaultState = () => {
    console.log('user requested default state');
    return {
        systemOperationRecords: {},
        timeFilteredReports: {},
        error: null,
    };
};
const defaultDispatch = (action) => {
    if (action) {
        throw new Error('dont use default reducer, use SystemSelfCheckContext.Provider in owning view and initialize with local context ');
    }
};
export const SystemSelfCheckReducer = (prev, action) => {
    const update = { ...prev };
    return Object.assign(update, action);
};
export const SystemSelfCheckContext = createContext({ state: getDefaultState(), dispatch: defaultDispatch });
